import React, { useState } from "react";
import { useNavigate, Link, useLocation } from "react-router-dom";
import { useAuth } from "../lib/auth";
import { formatApiError } from "../lib/api";
import { Barbell, GoogleLogo, Eye, EyeSlash } from "@phosphor-icons/react";
import Logo from "../components/Logo";
import { toast } from "sonner";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPwd, setShowPwd] = useState(false);
  const [loading, setLoading] = useState(false);

  const from = location.state?.from || "/dashboard";

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Sesión iniciada");
      navigate(from, { replace: true });
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  const handleGoogle = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/dashboard";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen bg-app flex items-center justify-center p-4 noise-bg">
      <div className="w-full max-w-md card-base p-8 sm:p-10" data-testid="login-card">
        <div className="flex flex-col items-center text-center gap-3 mb-8">
          <Logo size={110} variant="red" />
          <div>
            <div className="font-display font-black text-3xl tracking-tighter uppercase leading-tight">Athlon Sports</div>
            <div className="text-xs text-muted uppercase tracking-widest">Training Control</div>
          </div>
        </div>

        <h1 className="font-display uppercase font-black text-4xl tracking-tighter mb-2">Iniciar Sesión</h1>
        <p className="text-muted text-sm mb-8">Accede a tu panel de entrenamiento</p>

        <form onSubmit={handleSubmit} className="space-y-5">
          <div>
            <label className="text-xs uppercase tracking-widest text-muted block mb-2">Usuario</label>
            <input
              type="email"
              name="email"
              autoComplete="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="input-base"
              required
              data-testid="login-email-input"
              placeholder="Usuario"
            />
          </div>
          <div>
            <label className="text-xs uppercase tracking-widest text-muted block mb-2">Contraseña</label>
            <div className="relative">
              <input
                type={showPwd ? "text" : "password"}
                name="password"
                autoComplete="current-password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="input-base pr-12"
                required
                data-testid="login-password-input"
                placeholder="Contraseña"
              />
              <button
                type="button"
                onClick={() => setShowPwd(!showPwd)}
                className="absolute right-3 top-1/2 -translate-y-1/2 text-muted hover:text-white transition-colors"
                data-testid="toggle-password-visibility"
                tabIndex={-1}
              >
                {showPwd ? <EyeSlash size={18} weight="bold" /> : <Eye size={18} weight="bold" />}
              </button>
            </div>
          </div>
          <button type="submit" disabled={loading} className="btn-primary w-full" data-testid="login-submit-btn">
            {loading ? "Ingresando..." : "Ingresar"}
          </button>
          <div className="text-right">
            <Link to="/forgot-password" className="text-xs uppercase tracking-widest text-muted hover:text-white transition-colors" data-testid="forgot-password-link">
              ¿Olvidaste tu contraseña?
            </Link>
          </div>
        </form>

        <div className="flex items-center gap-3 my-6">
          <div className="flex-1 h-px bg-[#262626]" />
          <span className="text-xs uppercase tracking-widest text-muted">o</span>
          <div className="flex-1 h-px bg-[#262626]" />
        </div>

        <button onClick={handleGoogle} className="btn-secondary w-full flex items-center justify-center gap-2" data-testid="google-login-btn">
          <GoogleLogo size={18} weight="bold" />
          Continuar con Google
        </button>

        <p className="text-sm text-muted text-center mt-6">
          ¿No tenés cuenta?{" "}
          <Link to="/register" className="text-white hover:text-primary-app font-semibold" data-testid="register-link">
            Registrate
          </Link>
        </p>
      </div>
    </div>
  );
}
